import _toConsumableArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldSet from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";

var _globalThis$document, _globalThis$document2;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

function _classStaticPrivateFieldSpecSet(receiver, classConstructor, descriptor, value) { _classCheckPrivateStaticAccess(receiver, classConstructor); _classCheckPrivateStaticFieldDescriptor(descriptor, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) { _classCheckPrivateStaticAccess(receiver, classConstructor); _classCheckPrivateStaticFieldDescriptor(descriptor, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classCheckPrivateStaticFieldDescriptor(descriptor, action) { if (descriptor === undefined) { throw new TypeError("attempted to " + action + " private static field before its declaration"); } }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { _classCheckPrivateStaticAccess(receiver, classConstructor); return method; }

function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }

import "core-js/modules/esnext.global-this.js";

/**
 * Custom Media Element
 * Based on https://github.com/muxinc/custom-video-element - Mux - MIT License
 *
 * The goal is to create an element that works just like the video element
 * but can be extended/sub-classed, because native elements cannot be
 * extended today across browsers.
 */
// The onevent like props are weirdly set on the HTMLElement prototype with other
// generic events making it impossible to pick these specific to HTMLMediaElement.
export var Events = ['abort', 'canplay', 'canplaythrough', 'durationchange', 'emptied', 'encrypted', 'ended', 'error', 'loadeddata', 'loadedmetadata', 'loadstart', 'pause', 'play', 'playing', 'progress', 'ratechange', 'seeked', 'seeking', 'stalled', 'suspend', 'timeupdate', 'volumechange', 'waiting', 'waitingforkey', 'resize', 'enterpictureinpicture', 'leavepictureinpicture', 'webkitbeginfullscreen', 'webkitendfullscreen', 'webkitpresentationmodechanged'];
export var audioTemplate = (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.createElement('template');

if (audioTemplate) {
  audioTemplate.innerHTML =
  /*html*/
  "\n    <style>\n      :host {\n        display: inline-flex;\n        line-height: 0;\n        flex-direction: column;\n        justify-content: end;\n      }\n\n      audio {\n        width: 100%;\n      }\n    </style>\n    <slot name=\"media\"></slot>\n    <slot></slot>\n  ";
} // If the `media` slot is used leave the styling up to the user.
// It's a more consistent behavior pre and post custom element upgrade.


export var videoTemplate = (_globalThis$document2 = globalThis.document) === null || _globalThis$document2 === void 0 ? void 0 : _globalThis$document2.createElement('template');

if (videoTemplate) {
  videoTemplate.innerHTML =
  /*html*/
  "\n    <style>\n      :host {\n        display: inline-block;\n        line-height: 0;\n      }\n\n      video {\n        max-width: 100%;\n        max-height: 100%;\n        min-width: 100%;\n        min-height: 100%;\n        object-fit: var(--media-object-fit, contain);\n        object-position: var(--media-object-position, 50% 50%);\n      }\n\n      video::-webkit-media-text-track-container {\n        transform: var(--media-webkit-text-track-transform);\n        transition: var(--media-webkit-text-track-transition);\n      }\n    </style>\n    <slot name=\"media\"></slot>\n    <slot></slot>\n  ";
}
/**
 * @see https://justinfagnani.com/2015/12/21/real-mixins-with-javascript-classes/
 */


export var CustomMediaMixin = function CustomMediaMixin(superclass, _ref) {
  var _globalThis$document3, _class, _isInit, _nativeEl, _childMap, _init, _syncMediaChildren, _upgradeProperty, _forwardAttribute, _isDefined;

  var tag = _ref.tag,
      is = _ref.is;
  // `is` makes it possible to extend a custom built-in. e.g. castable-video
  var nativeElTest = (_globalThis$document3 = globalThis.document) === null || _globalThis$document3 === void 0 ? void 0 : _globalThis$document3.createElement(tag, {
    is: is
  });
  var nativeElProps = nativeElTest ? getNativeElProps(nativeElTest) : [];
  return _isInit = /*#__PURE__*/new WeakMap(), _nativeEl = /*#__PURE__*/new WeakMap(), _childMap = /*#__PURE__*/new WeakMap(), _init = /*#__PURE__*/new WeakSet(), _syncMediaChildren = /*#__PURE__*/new WeakSet(), _upgradeProperty = /*#__PURE__*/new WeakSet(), _forwardAttribute = /*#__PURE__*/new WeakSet(), (_class = /*#__PURE__*/function (_superclass) {
    _inherits(CustomMedia, _superclass);

    var _super = _createSuper(CustomMedia);

    function CustomMedia() {
      var _this;

      _classCallCheck(this, CustomMedia);

      _this = _super.call(this);

      _classPrivateMethodInitSpec(_assertThisInitialized(_this), _forwardAttribute);

      _classPrivateMethodInitSpec(_assertThisInitialized(_this), _upgradeProperty);

      _classPrivateMethodInitSpec(_assertThisInitialized(_this), _syncMediaChildren);

      _classPrivateMethodInitSpec(_assertThisInitialized(_this), _init);

      _classPrivateFieldInitSpec(_assertThisInitialized(_this), _isInit, {
        writable: true,
        value: void 0
      });

      _classPrivateFieldInitSpec(_assertThisInitialized(_this), _nativeEl, {
        writable: true,
        value: void 0
      });

      _classPrivateFieldInitSpec(_assertThisInitialized(_this), _childMap, {
        writable: true,
        value: new Map()
      });

      if (!_this.shadowRoot) {
        _this.attachShadow({
          mode: 'open'
        });

        _this.shadowRoot.append(_this.constructor.template.content.cloneNode(true));
      } // If the custom element is defined before the custom element's HTML is parsed
      // no attributes will be available in the constructor (construction process).
      // Wait until initializing in the attributeChangedCallback or
      // connectedCallback or accessing any properties.


      return _this;
    }

    _createClass(CustomMedia, [{
      key: "nativeEl",
      get: function get() {
        var _ref2, _ref3, _classPrivateFieldGet2;

        return (_ref2 = (_ref3 = (_classPrivateFieldGet2 = _classPrivateFieldGet(this, _nativeEl)) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : this.shadowRoot.querySelector(tag)) !== null && _ref3 !== void 0 ? _ref3 : this.querySelector(':scope > [slot=media]')) !== null && _ref2 !== void 0 ? _ref2 : this.querySelector(tag);
      },
      set: function set(val) {
        _classPrivateFieldSet(this, _nativeEl, val);
      }
    }, {
      key: "defaultMuted",
      get: function get() {
        return this.hasAttribute('muted');
      },
      set: function set(val) {
        this.toggleAttribute('muted', Boolean(val));
      }
    }, {
      key: "src",
      get: function get() {
        return this.getAttribute('src');
      },
      set: function set(val) {
        this.setAttribute('src', "".concat(val));
      }
    }, {
      key: "preload",
      get: function get() {
        var _this$getAttribute, _this$nativeEl;

        return (_this$getAttribute = this.getAttribute('preload')) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : (_this$nativeEl = this.nativeEl) === null || _this$nativeEl === void 0 ? void 0 : _this$nativeEl.preload;
      },
      set: function set(val) {
        this.setAttribute('preload', "".concat(val));
      }
    }, {
      key: "init",
      value: function init() {
        // If there is no nativeEl by now, create it.
        if (!this.nativeEl) {
          var nativeEl = document.createElement(tag, {
            is: is
          });
          nativeEl.part = tag;
          var mediaSlot = this.shadowRoot.querySelector('slot[name="media"]');
          mediaSlot.append(nativeEl);
        } // Neither Chrome or Firefox support setting the muted attribute
        // after using document.createElement.
        // Get around this by setting the muted property manually.


        this.nativeEl.muted = this.hasAttribute('muted');

        var _iterator = _createForOfIteratorHelper(nativeElProps),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var prop = _step.value;

            _classPrivateMethodGet(this, _upgradeProperty, _upgradeProperty2).call(this, prop);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.shadowRoot.addEventListener('slotchange', this);

        var _iterator2 = _createForOfIteratorHelper(this.constructor.Events),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _this$shadowRoot$addE, _this$shadowRoot;

            var type = _step2.value;
            (_this$shadowRoot$addE = (_this$shadowRoot = this.shadowRoot).addEventListener) === null || _this$shadowRoot$addE === void 0 ? void 0 : _this$shadowRoot$addE.call(_this$shadowRoot, type, this, true);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }, {
      key: "handleEvent",
      value: function handleEvent(event) {
        if (event.type === 'slotchange') {
          _classPrivateMethodGet(this, _syncMediaChildren, _syncMediaChildren2).call(this);

          return;
        }

        if (event.target === this.nativeEl) {
          // The video events are dispatched on the CustomMediaElement instance.
          // This makes it possible to add event listeners before the element is upgraded.
          this.dispatchEvent(new CustomEvent(event.type, {
            detail: event.detail
          }));
        }
      }
      /**
       * Keep some native child elements like track and source in sync.
       * An unnamed <slot> will be filled with all of the custom element's
       * top-level child nodes that do not have the slot attribute.
       */

    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(attrName, oldValue, newValue) {
        // Initialize right after construction when the attributes become available.
        _classPrivateMethodGet(this, _init, _init2).call(this);

        _classPrivateMethodGet(this, _forwardAttribute, _forwardAttribute2).call(this, attrName, oldValue, newValue);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        _classPrivateMethodGet(this, _init, _init2).call(this);
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        var _nativeElTest$constru, _nativeElTest$constru2;

        _classStaticPrivateMethodGet(CustomMedia, _class, _define).call(CustomMedia); // Include any attributes from the custom built-in.


        var natAttrs = (_nativeElTest$constru = nativeElTest === null || nativeElTest === void 0 ? void 0 : (_nativeElTest$constru2 = nativeElTest.constructor) === null || _nativeElTest$constru2 === void 0 ? void 0 : _nativeElTest$constru2.observedAttributes) !== null && _nativeElTest$constru !== void 0 ? _nativeElTest$constru : [];
        return [].concat(_toConsumableArray(natAttrs), ['autopictureinpicture', 'disablepictureinpicture', 'disableremoteplayback', 'autoplay', 'controls', 'controlslist', 'crossorigin', 'loop', 'muted', 'playsinline', 'poster', 'preload', 'src']);
      }
    }]);

    return CustomMedia;
  }(superclass), _defineProperty(_class, "Events", Events), _defineProperty(_class, "template", tag.endsWith('audio') ? audioTemplate : videoTemplate), _isDefined = {
    writable: true,
    value: void 0
  }, _class);

  function _define() {
    var _this2 = this;

    if (_classStaticPrivateFieldSpecGet(this, _class, _isDefined)) return;

    _classStaticPrivateFieldSpecSet(this, _class, _isDefined, true);

    var propsToAttrs = new Set(this.observedAttributes); // defaultMuted maps to the muted attribute, handled manually below.

    propsToAttrs.delete('muted'); // Passthrough native el functions from the custom el to the native el

    var _iterator3 = _createForOfIteratorHelper(nativeElProps),
        _step3;

    try {
      var _loop = function _loop() {
        var prop = _step3.value;
        if (prop in _this2.prototype) return "continue";
        var type = typeof nativeElTest[prop];

        if (type == 'function') {
          // Function
          _this2.prototype[prop] = function () {
            var _this3 = this;

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            _classPrivateMethodGet(this, _init, _init2).call(this);

            var fn = function fn() {
              if (_this3.call) return _this3.call.apply(_this3, [prop].concat(args));
              return _this3.nativeEl[prop].apply(_this3.nativeEl, args);
            };

            return fn();
          };
        } else {
          // Some properties like src, preload, defaultMuted are handled manually.
          // Getter
          var config = {
            get: function get() {
              var _this$get, _this$get2, _this$nativeEl2;

              _classPrivateMethodGet(this, _init, _init2).call(this);

              var attr = prop.toLowerCase();

              if (propsToAttrs.has(attr)) {
                var val = this.getAttribute(attr);
                return val === null ? false : val === '' ? true : val;
              }

              return (_this$get = (_this$get2 = this.get) === null || _this$get2 === void 0 ? void 0 : _this$get2.call(this, prop)) !== null && _this$get !== void 0 ? _this$get : (_this$nativeEl2 = this.nativeEl) === null || _this$nativeEl2 === void 0 ? void 0 : _this$nativeEl2[prop];
            }
          };

          if (prop !== prop.toUpperCase()) {
            // Setter (not a CONSTANT)
            config.set = function (val) {
              _classPrivateMethodGet(this, _init, _init2).call(this);

              var attr = prop.toLowerCase();

              if (propsToAttrs.has(attr)) {
                if (val === true || val === false || val == null) {
                  this.toggleAttribute(attr, Boolean(val));
                } else {
                  this.setAttribute(attr, val);
                }

                return;
              }

              if (this.set) {
                this.set(prop, val);
                return;
              }

              this.nativeEl[prop] = val;
            };
          }

          Object.defineProperty(_this2.prototype, prop, config);
        }
      };

      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  function _init2() {
    if (_classPrivateFieldGet(this, _isInit)) return;

    _classPrivateFieldSet(this, _isInit, true);

    this.init();
  }

  function _syncMediaChildren2() {
    var _this4 = this;

    var removeNativeChildren = new Map(_classPrivateFieldGet(this, _childMap));
    this.shadowRoot.querySelector('slot:not([name])').assignedElements().filter(function (el) {
      return ['track', 'source'].includes(el.localName);
    }).forEach(function (el) {
      var _this4$nativeEl$appen, _this4$nativeEl;

      // If the source or track is still in the assigned elements keep it.
      removeNativeChildren.delete(el); // Re-use clones if possible.

      var clone = _classPrivateFieldGet(_this4, _childMap).get(el);

      if (!clone) {
        clone = el.cloneNode();

        _classPrivateFieldGet(_this4, _childMap).set(el, clone);
      }

      (_this4$nativeEl$appen = (_this4$nativeEl = _this4.nativeEl).append) === null || _this4$nativeEl$appen === void 0 ? void 0 : _this4$nativeEl$appen.call(_this4$nativeEl, clone);
    });
    removeNativeChildren.forEach(function (el) {
      return el.remove();
    });
  }

  function _upgradeProperty2(prop) {
    // Sets properties that are set before the custom element is upgraded.
    // https://web.dev/custom-elements-best-practices/#make-properties-lazy
    if (Object.prototype.hasOwnProperty.call(this, prop)) {
      var value = this[prop]; // Delete the set property from this instance.

      delete this[prop]; // Set the value again via the (prototype) setter on this class.

      this[prop] = value;
    }
  }

  function _forwardAttribute2(attrName, oldValue, newValue) {
    // Ignore a few that don't need to be passed.
    if (['id', 'class'].includes(attrName)) {
      return;
    } // Ignore setting custom attributes from the child class.
    // They should not have any effect on the native element, it adds noise in the DOM.


    if (!_class.observedAttributes.includes(attrName) && this.constructor.observedAttributes.includes(attrName)) {
      return;
    }

    if (newValue === null) {
      var _this$nativeEl$remove, _this$nativeEl3;

      (_this$nativeEl$remove = (_this$nativeEl3 = this.nativeEl).removeAttribute) === null || _this$nativeEl$remove === void 0 ? void 0 : _this$nativeEl$remove.call(_this$nativeEl3, attrName);
    } else {
      var _this$nativeEl$getAtt, _this$nativeEl4;

      if (((_this$nativeEl$getAtt = (_this$nativeEl4 = this.nativeEl).getAttribute) === null || _this$nativeEl$getAtt === void 0 ? void 0 : _this$nativeEl$getAtt.call(_this$nativeEl4, attrName)) != newValue) {
        var _this$nativeEl$setAtt, _this$nativeEl5;

        (_this$nativeEl$setAtt = (_this$nativeEl5 = this.nativeEl).setAttribute) === null || _this$nativeEl$setAtt === void 0 ? void 0 : _this$nativeEl$setAtt.call(_this$nativeEl5, attrName, newValue);
      }
    }
  }
};

function getNativeElProps(nativeElTest) {
  // Map all native element properties to the custom element
  // so that they're applied to the native element.
  // Skipping HTMLElement because of things like "attachShadow"
  // causing issues. Most of those props still need to apply to
  // the custom element.
  var nativeElProps = []; // Walk the prototype chain up to HTMLElement.
  // This will grab all super class props in between.
  // i.e. VideoElement and MediaElement

  for (var proto = Object.getPrototypeOf(nativeElTest); proto && proto !== HTMLElement.prototype; proto = Object.getPrototypeOf(proto)) {
    nativeElProps.push.apply(nativeElProps, _toConsumableArray(Object.getOwnPropertyNames(proto)));
  }

  return nativeElProps;
}

export var CustomVideoElement = globalThis.document ? CustomMediaMixin(HTMLElement, {
  tag: 'video'
}) : /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }

  return _createClass(_class2);
}();
export var CustomAudioElement = globalThis.document ? CustomMediaMixin(HTMLElement, {
  tag: 'audio'
}) : /*#__PURE__*/function () {
  function _class3() {
    _classCallCheck(this, _class3);
  }

  return _createClass(_class3);
}();